module.exports = __webpack_public_path__ + "static/media/UploadingFiles.3cad7d9e.svg";